import { ArrowUpRight } from "lucide-react";
import SectionBadge from "@/components/site/SectionBadge";

const PARAGRAPHS = [
  "Over the course of 16 years leading corporate strategy, category management, and marketing teams—including my time as a Chief Marketing Officer—I experienced a recurring theme. The biggest threat to a company's bottom line wasn't a lack of ambition; it was a lack of alignment.",
  "The agencies didn't understand the sales targets. The consultants didn't understand the creative execution.",
  "I founded BLEZZINGS Growth Partners to be the commercial engine that businesses actually need. We approach every client challenge not just as strategists, but as former P&L owners. We know that top-line traffic means nothing if it destroys your margins. We believe that strategy without execution is just hallucination.",
  "Whether we are architecting your go-to-market plan, producing your cinematic brand assets, or re-engineering your sales pipeline, our focus remains on a single, uncompromising metric: sustainable, profitable growth.",
];

export default function FounderNote({ onBook }) {
  return (
    <section
      id="founder-note"
      data-testid="founder-note-section"
      className="pt-16 md:pt-20 pb-24 md:pb-32 bg-white"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 md:px-12">
        <SectionBadge label="A Note from the Founder" />
        <h2 className="font-serif-display text-4xl sm:text-5xl mt-6 leading-[1.05]">
          Leadership Philosophy
        </h2>

        <blockquote
          data-testid="founder-note-quote"
          className="mt-10 border-l-2 border-black pl-6 sm:pl-8 space-y-6 text-lg text-zinc-700 leading-relaxed"
        >
          {PARAGRAPHS.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </blockquote>

        <div className="mt-8 font-serif-display text-xl text-black leading-snug">
          — Khalid Kamal Rumi
          <div className="text-sm font-sans not-italic text-zinc-500 mt-1 tracking-wide">
            Founder &amp; CEO, BLEZZINGS (Alumnus, IIM Indore)
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <button
            data-testid="founder-note-book-btn"
            onClick={onBook}
            className="group inline-flex items-center gap-3 h-12 px-7 bg-black text-white text-[15px] font-medium hover:bg-black transition-colors duration-300"
          >
            Book a Consultation
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </button>
          <a
            data-testid="founder-note-gp-link"
            href="/businesses/growth-partners"
            className="group inline-flex items-center gap-2 h-12 px-6 border border-black text-[15px] font-medium text-black hover:bg-black hover:text-white transition-colors duration-300"
          >
            Explore Growth Partners
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
